import React, { useEffect, useState } from "react";
import OfferSection from "../../../components/CommonCompnents/Home/OfferSection";
import {
  constants,
  errorsMsg,
  GetAccecssTitle,
  GetAccessSignup,
  Offers,
  OfferTitle,
  PartnersDetails,
  removeServerErrors,
} from "../../Constants/commenFeatures";
import "../../../assets/scss/components/home.scss";
import "../../../assets/scss/vendor_scss/signup.scss";
import GetAccess from "../../../components/CommonCompnents/Home/GetAccess";
import Footer from "../../Common/Footer";
import EdButton from "../../../components/generic/edButton";
import InputField from "../../../components/generic/inputField";
import { ReqACallForm, ReqACallFormErr } from "./signupConstensts";
import Autocomplete from "../../../components/generic/autocomplete";
import {
  alphabetExp,
  betweenNChars,
  emailRegex,
  integerExp,
  phoneNo,
} from "../../../components/utils/regex";
import { locateUs } from "../../../services/login/loginApiService";
import { vendorReqACall } from "../../../services/Signup/SignupApiServices";
import ErrorMsg from "../../../components/CommonCompnents/ErrorMsg";
import NuvamaLogo from "../../../assets/new_images/nuvama-logo.svg";
import useDocumentTitle from "../../../utils/useDocumentTitle";

const ReqACall: React.FC = () => {
  const [signupFormVal, setSignupFormVal] = useState(ReqACallForm);
  const [signupErr, setSignupErr] = useState(ReqACallFormErr);
  const [allCities, setAllCities] = useState<any[]>([]);
  const [filteredCities, setFilteredCities] = useState<any[] | null>(null);
  const [signupModal, setSignupModal] = useState<boolean>(false);
  useDocumentTitle("Request a Call - Partner Sign Up");
  const [isServerErr, setIsServerErr] = useState({
    successRes: "",
    failedRes: "",
    limitExceeded: "",
  });

  const showSignUpModal = (val: boolean) => {
    setSignupModal(val);
  };

  const submitSignupFormRes = (res: any) => {
    showSignUpModal(false);
    window.scrollTo(0, 0);
    if (res && res.data) {
      setSignupFormVal(ReqACallForm);
      setIsServerErr({
        successRes: res.data.msg,
        failedRes: "",
        limitExceeded: "",
      });
    } else if (res && res.error) {
      setIsServerErr({
        successRes: "",
        failedRes: res.error.errMsg || errorsMsg.commonError,
        limitExceeded: "",
      });
    }
  };

  const submitSignupForm = (e: any) => {
    e.preventDefault();
    vendorReqACall(submitSignupFormRes, signupFormVal);
  };

  function onChangeSignupForm(key: string, value: string) {
    if (key === "city") {
      const [city, state = ""] = value.split(";");
      setSignupFormVal({
        ...signupFormVal,
        city: city.replace(/\w\S*/g, (w) =>
          w.replace(/^\w/, (c) => c.toUpperCase())
        ),
        state: state.replace(/\w\S*/g, (w) =>
          w.replace(/^\w/, (c) => c.toUpperCase())
        ),
      });

      if (city.length > 2) {
        const search = city.toLowerCase();
        const seen = new Set<string>();
        const matches = allCities.filter((c: any) => {
          const name: string = (c.city_name || "").toLowerCase();
          if (!name.includes(search) || seen.has(name)) return false;
          seen.add(name);
          return true;
        });
        setFilteredCities(matches);
      } else {
        setFilteredCities(null);
      }
    } else {
      if (
        (key === "name" && !alphabetExp.test(value)) ||
        (key === "phn" && !integerExp.test(value))
      ) {
        value = signupFormVal[key];
      }
      setSignupFormVal({ ...signupFormVal, [key]: value });
    }
    setSignupErr({ ...signupErr, [key]: "" });
    return value;
  }

  function getCitiesRes(res: any) {
    if (res.data) {
      setAllCities(res.data);
    }
  }

  function handleACBlur(value: any) {
    if (!value) {
      setSignupErr({
        ...signupErr,
        city: "Please enter atleast 3 characters of city name",
      });
    } else if (value.split(";").length !== 2) {
      setSignupErr({
        ...signupErr,
        city: "Please enter a valid city name",
      });
    }
  }
  useEffect(() => {
    locateUs(getCitiesRes);
  }, []);

  const removeIsServerErrors = () => {
    setIsServerErr({
      successRes: "",
      failedRes: "",
      limitExceeded: "",
    });
  };
  useEffect(() => {
    if (
      isServerErr.successRes !== "" ||
      isServerErr.failedRes !== "" ||
      isServerErr.limitExceeded !== ""
    ) {
      removeServerErrors(removeIsServerErrors, constants.ErrorTimeout);
    }
  }, [isServerErr]);
  return (
    <div>
      <ErrorMsg isServerErr={isServerErr} />
      <div className="vendor-pre-signup">
        <div className="top_section">
          <div className="left_section">
            <div className="bg_img">
              <div className="section-content">
                <h1>Build, Integrate & Trade with our restful APIs</h1>
                <p>
                  <span>For Start-up | Fintect | Market Analyst | Algo</span>
                  <span>Platform providers | Tech Giants</span>
                </p>
                <button
                  className="btn request_call"
                  onClick={() => showSignUpModal(true)}
                >
                  Request a Call
                </button>
              </div>
            </div>
          </div>
          <div className="right_section">
            <h2>Get customised high revenue </h2>
            <form className="signup_form" onSubmit={(e) => submitSignupForm(e)}>
              <label htmlFor="name" className="inp_lbl mg-b5 ib">Name</label>
              <InputField
                id="name"
                pattern={betweenNChars(3)}
                onChange={(value) => onChangeSignupForm("name", value)}
                onBlur={(error: any) =>
                  setSignupErr({
                    ...signupErr,
                    name: error.pattern
                      ? ""
                      : "Please enter at least 3 character",
                  })
                }
                defaultValue={signupFormVal.name}
                className="login_inp mg-b40"
                placeholder="Eg: Name Surname"
                errorText={signupErr.name}
              />

              <label htmlFor="email" className="inp_lbl mg-b5 ib">Email ID</label>
              <InputField
                id="email"
                pattern={emailRegex}
                onChange={(value) => onChangeSignupForm("email", value)}
                onBlur={(error) =>
                  setSignupErr({
                    ...signupErr,
                    email: error.pattern ? "" : "Please enter a valid email id",
                  })
                }
                defaultValue={signupFormVal.email}
                className="login_inp mg-b40"
                placeholder="Eg: example@email.com"
                errorText={signupErr.email}
              />

              <label htmlFor="phone-number" className="inp_lbl mg-b5 ib">Phone Number</label>
              <div className="phone_no">
                <span aria-label="Country code plus ninety one" className="cntry_code mg-b30 ib mg-r20">+91</span>
                <InputField
                  id="phone-number"
                  type="tel"
                  pattern={phoneNo}
                  onChange={(value) => onChangeSignupForm("phn", value)}
                  onBlur={(error) =>
                    setSignupErr({
                      ...signupErr,
                      phn: error.pattern
                        ? ""
                        : "Please enter a valid phone number",
                    })
                  }
                  defaultValue={signupFormVal.phn}
                  className="login_inp mg-b30"
                  placeholder="Eg: 980908XXXX"
                  errorText={signupErr.phn}
                />
              </div>

              <label htmlFor="city-input" className="inp_lbl mg-b5 ib">City</label>
              {/* We have to store state also along with city because state is required in api request.
					Index of cities is not stored in value because it may change when user clicks on a city (api is called again)
					That is why both city and state are stored in value
					This also helps to check if the value in input is typed by the user or selected from the dropdown */}
              <Autocomplete
                id="city-input"
                data={
                  filteredCities
                    ? filteredCities.map((city: any) => ({
                        value: city.city_name + ";" + (city.state_name || ""),
                        display: city.city_name,
                      }))
                    : null
                }
                onOptionSelect={(value: any) =>
                  onChangeSignupForm("city", value.value)
                }
                noDataMsg="City with similar name not found"
                onChange={(value: any) => onChangeSignupForm("city", value)}
                inputClassName="login_inp mg-b40"
                placeholder="Eg: Mumbai"
                onBlur={handleACBlur}
                name="city"
                defaultValue={signupFormVal.city}
                className="city"
                errorText={signupErr.city}
              />
              <label htmlFor="company-name" className="inp_lbl mg-b5 ib">Company Name</label>
              <InputField
                id="company-name"
                pattern={betweenNChars(3)}
                onChange={(value) => onChangeSignupForm("cpNm", value)}
                onBlur={(error) =>
                  setSignupErr({
                    ...signupErr,
                    cpNm: error.pattern
                      ? ""
                      : "Please enter at least 3 character",
                  })
                }
                defaultValue={signupFormVal.cpNm}
                className="login_inp mg-b40"
                placeholder="Eg: Example Pvt. Ltd."
                errorText={signupErr.cpNm}
              />

              <EdButton
                value="Request a Call"
                type="submit"
                btnTyp="primary"
                className="submit_btn"
                disabled={
                  Object.values(signupErr).some((error) => error) ||
                  Object.values(signupFormVal).some((value) => !value)
                }
              />
            </form>
          </div>
        </div>
        <div className="bottom_section">
          <div className="presignup_left">
            <div className="offer_section">
              <div className="homeWrap">
                <div className="learnTrade container">
                  <div>
                    <OfferSection
                      Offers={Offers}
                      title={OfferTitle.SIGNUP_TITLE}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="getAccess_section">
              <div className="homeWrap ">
                <GetAccess
                  title={GetAccecssTitle.SIGNUP_TITLE}
                  GetAccessData={GetAccessSignup}
                />
              </div>
            </div>
            <div className="partner_section">
              <div className="container">
                <h2>Our Partners</h2>
                <div className="partner_description">
                  {PartnersDetails.map((partner: any, i: number) => {
                    return (
                      <div key={i} className="partner">
                        {partner.icon ? (
                          <img
                            className="logo1"
                            src={partner.icon}
                            alt={partner.name}
                          />
                        ) : null}
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
          <div className="presignup_right"></div>
        </div>
        <div
          id={signupModal ? "show_modal" : "hide_modal"}
          className="modal_signup"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal-heading"
        >
          <div className="modal_content_signup">
            <div className="signup_form_header">
              <div className="close_logo">
                <button
                  type="button"
                  aria-label="Close modal"
                  onClick={() => showSignUpModal(false)}
                  style={{ background: "none", border: "none", cursor: "pointer" }}
                >
                  <i className="edel-icon-close" aria-hidden="true" />
                </button>
              </div>
              <div className="edelwiess_logo">
                <span>
                  <img className="logo1" src={NuvamaLogo} alt="nuvama-logo" />
                </span>
                <button
                  type="button"
                  aria-label="Close modal"
                  onClick={() => showSignUpModal(false)}
                  style={{ background: "none", border: "none", cursor: "pointer" }}
                >
                  <i className="edel-icon-close" aria-hidden="true" />
                </button>
              </div>
              <h1 id="modal-heading">Get customised high revenue sharing plan with our APIs</h1>
            </div>
            <form className="signup_form" onSubmit={(e) => submitSignupForm(e)}>
              <label htmlFor="name" className="inp_lbl mg-b5 ib">Name</label>
              <InputField
                id="name"
                pattern={betweenNChars(3)}
                onChange={(value: any) => onChangeSignupForm("name", value)}
                onBlur={(error: any) =>
                  setSignupErr({
                    ...signupErr,
                    name: error.pattern
                      ? ""
                      : "Please enter at least 3 character",
                  })
                }
                defaultValue={signupFormVal.name}
                className="login_inp mg-b40"
                placeholder="Eg: Name Surname"
                errorText={signupErr.name}
              />

              <label htmlFor="email" className="inp_lbl mg-b5 ib">Email ID</label>
              <InputField
                id="email"
                pattern={emailRegex}
                onChange={(value: any) => onChangeSignupForm("email", value)}
                onBlur={(error: any) =>
                  setSignupErr({
                    ...signupErr,
                    email: error.pattern ? "" : "Please enter a valid email id",
                  })
                }
                defaultValue={signupFormVal.email}
                className="login_inp mg-b40"
                placeholder="Eg: example@email.com"
                errorText={signupErr.email}
              />

              <label htmlFor="phone-input" className="inp_lbl mg-b5 ib">Phone Number</label>
              <div className="phone_no">
                <span aria-label="Country code plus ninety one" className="cntry_code mg-b30 ib mg-r20">+91</span>
                <InputField
                  id="phone-input"
                  type="tel"
                  pattern={phoneNo}
                  onChange={(value: any) => onChangeSignupForm("phn", value)}
                  onBlur={(error: any) =>
                    setSignupErr({
                      ...signupErr,
                      phn: error.pattern
                        ? ""
                        : "Please enter a valid phone number",
                    })
                  }
                  defaultValue={signupFormVal.phn}
                  className="login_inp mg-b30"
                  placeholder="Eg: 980908XXXX"
                  errorText={signupErr.phn}
                />
              </div>

              <label htmlFor="city-input" className="inp_lbl mg-b5 ib">City</label>
              {/* We have to store state also along with city because state is required in api request.
					Index of cities is not stored in value because it may change when user clicks on a city (api is called again)
					That is why both city and state are stored in value
					This also helps to check if the value in input is typed by the user or selected from the dropdown */}
              <Autocomplete
                id="city-input"
                data={
                  filteredCities
                    ? filteredCities.map((city: any) => ({
                        value: city.city_name + ";" + (city.state_name || ""),
                        display: city.city_name,
                      }))
                    : null
                }
                onOptionSelect={(value: any) =>
                  onChangeSignupForm("city", value.value)
                }
                noDataMsg="City with similar name not found"
                onChange={(value) => onChangeSignupForm("city", value)}
                inputClassName="login_inp mg-b40"
                placeholder="Eg: Mumbai"
                onBlur={handleACBlur}
                name="city"
                defaultValue={signupFormVal.city}
                className="city"
                errorText={signupErr.city}
              />
              <label htmlFor="company-name" className="inp_lbl mg-b5 ib">Company Name</label>
              <InputField
                id="company-name"
                pattern={betweenNChars(3)}
                onChange={(value) => onChangeSignupForm("cpNm", value)}
                onBlur={(error) =>
                  setSignupErr({
                    ...signupErr,
                    cpNm: error.pattern
                      ? ""
                      : "Please enter at least 3 character",
                  })
                }
                defaultValue={signupFormVal.cpNm}
                className="login_inp mg-b40"
                placeholder="Eg: Example Pvt. Ltd."
                errorText={signupErr.cpNm}
              />

              <EdButton
                value="Request a Call"
                type="submit"
                btnTyp="primary"
                className="submit_btn"
                disabled={
                  Object.values(signupErr).every((error) => error) ||
                  Object.values(signupFormVal).some((value) => !value)
                }
              />
            </form>

            <div className="mob_footer">
              <EdButton
                value="Request a Call"
                type="button"
                btnTyp="primary"
                className="submit_btn"
                onClick={(e) => submitSignupForm(e)}
                disabled={
                  Object.values(signupErr).some((error) => error) ||
                  Object.values(signupFormVal).some((value) => !value)
                }
              />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ReqACall;
